import { FC, ReactElement, useState } from "react";
import { 
  Box, 
  Stack, 
  Tab, 
  Tabs,
} from "@mui/material";
import AceDataView from "./AceDataView";
import CensusDataView from "./CensusDataView";

const TradeData: FC = (): ReactElement => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <Stack
      spacing={0}
      sx={{
        flex: 1,
        height: "100%",
        margin: {
          xs: "-6px -10px 0 -10px",
          md: "-12px -20px 0 -20px",
        },
        width: {
          xs: "calc(100% + 20px)",
          md: "calc(100% + 40px)",
        },
      }}
    >
      {/* Slim Tabs Header - matches Product Hub & Potential Savings */}
      <Box
        sx={(theme) => ({
          borderBottom: `1px solid ${theme.palette.divider}`,
          width: "100%",
        })}
      >
        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          sx={{ minHeight: 36, px: { xs: 2, md: 3 } }}
        >
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            sx={{
              minHeight: 36,
              "& .MuiTab-root": {
                textTransform: "none",
                fontWeight: 600,
                fontSize: "0.9rem",
                minHeight: 36,
                padding: "6px 12px",
                mr: 0.5,
                color: "text.secondary",
                "&:hover": {
                  color: "primary.main",
                  backgroundColor: "transparent",
                },
                "&.Mui-selected": {
                  color: "primary.main",
                },
              },
              "& .MuiTabs-indicator": {
                backgroundColor: "primary.main",
                height: 2,
                bottom: 0,
              },
            }}
          >
            <Tab label="ACE Data" sx={{ gap: 0.5, py: 0 }} />
            <Tab label="Commerce Data" sx={{ gap: 0.5, py: 0 }} />
          </Tabs>
        </Stack>
      </Box>

      {/* Content Area */}
      <Box sx={{ flex: 1, px: 3, pb: 3, overflow: "auto" }}>
        {activeTab === 0 ? <AceDataView /> : <CensusDataView />}
      </Box>
    </Stack>
  );
};

export default TradeData;
